import React, { useState } from 'react';
import './navbar.css';
import logo from '../../assets/logo.png';
import contactImg from '../../assets/contact.png';
import menu from '../../assets/menu.png';

import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (sectionId) => {
        setShowMenu(false);

        if (location.pathname !== "/") {
            navigate("/");

            // wait for homepage to render before scrolling
            setTimeout(() => {
                document.getElementById(sectionId)?.scrollIntoView({
                    behavior: "smooth"
                });
            }, 100);
        } else {
            document.getElementById(sectionId)?.scrollIntoView({
                behavior: "smooth"
            });
        }
    };

    return (
        <nav className="navbar">
            <img src={logo} alt="Logo" className='logo' onClick={() => handleNavigation("intro")} />

            <div className="desktopMenu">
                <button onClick={() => handleNavigation("intro")} className="desktopMenuListItem">Home</button>
                <button onClick={() => handleNavigation("skills")} className="desktopMenuListItem">About</button>
                <button onClick={() => handleNavigation("project-list-container")} className="desktopMenuListItem">Projects</button>
                <button onClick={() => handleNavigation("blog-list-container")} className="desktopMenuListItem">Blogs</button>
            </div>

            <button className="desktopMenuBtn" onClick={() => handleNavigation("contact")}>
                <img src={contactImg} alt="" className="desktopMenuImg" />
                Contact Me
            </button>

            <img
                src={menu}
                alt="Menu"
                className='mobMenu'
                onClick={() => setShowMenu(!showMenu)}
            />

            <div className="navMenu" style={{ display: showMenu ? 'flex' : 'none' }}>
                <button onClick={() => handleNavigation("intro")} className="listItem">Home</button>
                <button onClick={() => handleNavigation("skills")} className="listItem">About</button>
                <button onClick={() => handleNavigation("project-list-container")} className="listItem">Projects</button>
                <button onClick={() => handleNavigation("blog-list-container")} className="listItem">Blogs</button>
                <button onClick={() => handleNavigation("contact")} className="listItem">Contact</button>
            </div>
        </nav>
    );
};

export default Navbar;
// import React, { useState } from 'react';
// import './navbar.css';
// import logo from '../../assets/logo.png';
// import contactImg from '../../assets/contact.png';
// import menu from '../../assets/menu.png';
// import { Link } from 'react-scroll';

// const Navbar = () => {
//     const [showMenu, setShowMenu] = useState(false);
//     return (
//         <nav className="navbar">
//             <img src={logo} alt="Logo" className='logo'/>
//             <div className="desktopMenu">
//                 <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">Home</Link>
//                 <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">About</Link>
//                 <Link activeClass='active' to='project-list-container' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">Projects</Link>
//                 <Link activeClass='active' to='blog-list-container' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">Blogs</Link>
//             </div>
//             <button className="desktopMenuBtn"onClick={() => {
//                 document.getElementById('contact').scrollIntoView({behavior: 'smooth'});
//             }}>
//                 <img src={contactImg} alt="" className="desktopMenuImg" />Contact Me
//             </button>

//             <img src={menu} alt="Menu" className='mobMenu' onClick={()=>setShowMenu(!showMenu)}/>
//                 <div className="navMenu" style={{display: showMenu? 'flex':'none'}}>
//                     <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Home</Link>
//                     <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>About</Link>
//                     <Link activeClass='active' to='project-list-container' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Projects</Link>
//                     <Link activeClass='active' to='blog-list-container' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Blogs</Link>
//                     <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={()=>setShowMenu(false)}>Contact</Link>
//                 </div>
            
//         </nav>
//     )
// }

// export default Navbar;